import { Cursor } from '../../models/Repository';
import {
  Invitation,
  InvitationLink,
  InvitationType,
  RedemptionCode,
  SystemInvitation,
  SystemInvitationType,
} from '../../models/UserStore/Invitation';
import { NameCard } from '../../models/UserStore/NameCard';
import {
  InvitationLinkListField,
  InvitationListField,
  NameCardListField,
  RedemptionCodeListField,
  SystemInvitationListField,
  UserStoreState,
} from '../../models/UserStore/UserStore';

export const getInvitations = (
  state: UserStoreState,
  fieldName: InvitationListField,
) => state.invitations.list(fieldName).get();

export const getInvitation = (state: UserStoreState, invitationId: string) =>
  state.invitations.get(invitationId);

export const setInvitations = (
  state: UserStoreState,
  fieldName: InvitationListField | undefined,
  ...invitations: Invitation[]
) => {
  state.invitations
    .list(fieldName ?? InvitationType.Referral)
    .set(...invitations);
};

export const getSystemInvitations = (
  state: UserStoreState,
  fieldName: SystemInvitationListField,
) => state.systemInvitations.list(fieldName).get();

export const getSystemInvitation = (
  state: UserStoreState,
  systemInvitationId: string,
) => state.systemInvitations.get(systemInvitationId);

export const setSystemInvitations = (
  state: UserStoreState,
  fieldName: SystemInvitationListField | undefined,
  ...systemInvitations: SystemInvitation[]
) => {
  state.systemInvitations
    .list(fieldName ?? SystemInvitationType.JoinClub)
    .set(...systemInvitations);
};

export const pushInvitations = (
  state: UserStoreState,
  fieldName: InvitationListField | undefined,
  ...invitations: Invitation[]
) => {
  state.invitations
    .list(fieldName ?? InvitationType.Referral)
    .push(...invitations);
};

export const setInvitationCursor = (
  state: UserStoreState,
  fieldName: InvitationListField | undefined,
  cursor: Cursor,
) => {
  state.invitations
    .list(fieldName ?? InvitationType.Referral)
    .setCursor(cursor);
};

export const addInvitationToMap = (
  state: UserStoreState,
  type: InvitationType,
  userId: string,
  invitation: Invitation | null,
) => {
  state.invitations.map(type).set(userId, invitation);
};

export const pushSystemInvitations = (
  state: UserStoreState,
  fieldName: SystemInvitationListField | undefined,
  ...systemInvitations: SystemInvitation[]
) => {
  state.systemInvitations
    .list(fieldName ?? SystemInvitationType.JoinClub)
    .push(...systemInvitations);
};

export const setSystemInvitationCursor = (
  state: UserStoreState,
  fieldName: SystemInvitationListField | undefined,
  cursor: Cursor,
) => {
  state.systemInvitations
    .list(fieldName ?? SystemInvitationType.JoinClub)
    .setCursor(cursor);
};

export const addSystemInvitationToMap = (
  state: UserStoreState,
  type: SystemInvitationType,
  systemInvitationId: string,
  systemInvitation: SystemInvitation | null,
) => {
  state.systemInvitations.map(type).set(systemInvitationId, systemInvitation);
};

export const updateSystemInvitation = (
  state: UserStoreState,
  systemInvitation: SystemInvitation,
) => {
  state.systemInvitations.set(systemInvitation);
};

export const removeSystemInvitation = (
  state: UserStoreState,
  systemInvitation: SystemInvitation,
) => state.systemInvitations.delete(systemInvitation.id());

export const pushInvitationLinks = (
  state: UserStoreState,
  fieldName: InvitationLinkListField,
  ...invitationLinks: InvitationLink[]
) => {
  state.invitationLinks.list(fieldName).push(...invitationLinks);
};

export const setInvitationLinks = (
  state: UserStoreState,
  fieldName: InvitationLinkListField,
  ...invitationLinks: InvitationLink[]
) => {
  state.invitationLinks.list(fieldName).set(...invitationLinks);
};

export const setRedemptionCodes = (
  state: UserStoreState,
  fieldName: RedemptionCodeListField,
  ...redemptionCodes: RedemptionCode[]
) => {
  state.redemptionCodes.list(fieldName).set(...redemptionCodes);
};

export const setNameCards = (
  state: UserStoreState,
  fieldName: NameCardListField,
  ...nameCards: NameCard[]
) => {
  state.nameCards.list(fieldName).set(...nameCards);
};

export const updateNameCard = (state: UserStoreState, nameCard: NameCard) => {
  state.nameCards.set(nameCard);
};
